import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7;
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.pad-start.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { LitElement, html } from 'lit';
import dayjs from 'dayjs';
import css from "./style.pcss";
import IconCalendar from "./images/ic_calendar.svg";
var weekDays = ['SO', 'MÉ', 'DË', 'MË', 'DO', 'FR', 'SA'];
var months = ['JAN', 'FEB', 'MAR', 'APR', 'MEE', 'JUN', 'JUL', 'AUG', 'SEP', 'OKT', 'NOV', 'DEZ'];
var zeroDayKey = 0;
var NmDatePicker = /*#__PURE__*/function (_LitElement) {
  _inherits(NmDatePicker, _LitElement);
  function NmDatePicker() {
    var _this;
    _classCallCheck(this, NmDatePicker);
    _this = _callSuper(this, NmDatePicker);
    _this.value = dayjs().format('YYYY-MM-DD');
    _this.showPicker = false;
    _this.pickerDate = dayjs(`${dayjs().format('YYYY')}-${dayjs().format('MM')}-01`);
    return _this;
  }
  _createClass(NmDatePicker, [{
    key: "createRenderRoot",
    value: function createRenderRoot() {
      return this;
    } // keng shadowroot
  }, {
    key: "renderPicker",
    value: function renderPicker() {
      var _this2 = this;
      if (!this.showPicker) return null;
      return html(_t || (_t = _`<div class="date-picker">
            <div class="date-picker__month-container">
                <span class="date-picker__month-arrow" @click=${0}> < </span>
                <span class="date-picker__month">${0} ${0}</span>
                <span class="date-picker__month-arrow" @click=${0}> > </span>
            </div>
            <ul class="date-picker-calendar__weekdays">
                ${0}
            </ul>
            ${0}
        </div>`), function () {
        return _this2.pickerDate = _this2.pickerDate.add(-1, 'month');
      }, months[this.pickerDate.month()], this.pickerDate.year(), function () {
        return _this2.pickerDate = _this2.pickerDate.add(1, 'month');
      }, weekDays.map(function (d) {
        return html(_t2 || (_t2 = _`<li>${0}</li>`), d);
      }), this.drawCalendar());
    }
  }, {
    key: "drawCase",
    value: function drawCase(day) {
      var _this3 = this;
      var currentDate = this.pickerDate.year() + '-' + String(this.pickerDate.month() + 1).padStart(2, '0') + '-' + String(day).padStart(2, '0');
      if (day > 0) {
        return html(_t3 || (_t3 = _`<li @click=${0}>${0}</li>`), function (e) {
          _this3.value = currentDate;
          _this3.showPicker = false;
          e.stopPropagation();
        }, day);
      } else {
        zeroDayKey++;
        return html(_t4 || (_t4 = _`<li className='--other-month'> </li>`));
      }
    }
  }, {
    key: "drawRow",
    value: function drawRow(nRow) {
      var _this4 = this;
      var days = [];
      var firstDayOfWeek = this.pickerDate.day();
      var nDays = this.pickerDate.daysInMonth();
      if (nRow === 1) {
        for (var i = 1; i < firstDayOfWeek; i++) {
          days.push(0);
        }
        var dof = firstDayOfWeek === 0 ? 1 : firstDayOfWeek;
        for (var _i = dof; _i <= 7; _i++) {
          days.push(_i - firstDayOfWeek);
        }
      } else {
        for (var _i2 = 0; _i2 < 7; _i2++) {
          var newDay = _i2 + (nRow - 1) * 7 - firstDayOfWeek + 1;
          if (newDay > nDays) newDay = 0;
          days.push(newDay);
        }
      }
      return html(_t5 || (_t5 = _`<ul>
            ${0}
        </ul>`), days.map(function (day) {
        return _this4.drawCase(day);
      }));
    }
  }, {
    key: "drawCalendar",
    value: function drawCalendar() {
      var firstDayOfWeek = this.pickerDate.day();
      var nDays = this.pickerDate.daysInMonth();
      var nRows = 5;
      if (firstDayOfWeek > 5 || firstDayOfWeek >= 5 && nDays === 31) nRows++;
      return html(_t6 || (_t6 = _`
            <div>
                ${0}
            </div>
        `), Array.apply(null, Array(nRows)).map(function (item, i) {
        return this.drawRow(i + 1);
      }, this));
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;
      return html(_t7 || (_t7 = _`
            <style>${0}</style>
            <div class="date-picker__container">
                <input class="date-picker__chosen-date" @click=${0} readOnly type="text" value="${0}">
                <input onChange=${0} type="hidden" name=${0} value="${0}">
                <span @click=${0} class="input-group-addon">
                    <span class="date-picker-calendar__container">
                        <img class="date-picker-calendar__img" src="${0}"/>

                        ${0}
                    </span>
                </span>
            </div>
        `), css, function () {
        return _this5.showPicker = true;
      }, dayjs(this.value).format('DD.MM.YYYY'), this.onChange, this.name, this.value, function () {
        return _this5.showPicker = true;
      }, IconCalendar, this.renderPicker());
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        value: {
          type: String
        },
        name: {
          type: String
        },
        showPicker: {
          type: Boolean
        },
        onChange: {
          type: String
        },
        pickerDate: {
          type: Object
        }
      };
    }
  }]);
  return NmDatePicker;
}(LitElement);
export { NmDatePicker as default };
window.customElements.define('nm-date-picker', NmDatePicker);